// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test',
      //suggestionPosition: 'left'
  },
};
(function() {
	BoostPFS.inject(this);
	// Reszie Suggestion Box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
		if (!suggestionElement) suggestionElement = this.$uiMenuElement;   // Add this line
		if (!searchElement) searchElement = this.$element;  // Add this line
		if (!searchBoxId) searchBoxId = this.id; // Add this line
		// Set Width for Suggestion box when opening
		// By default, the width of Suggestion box is equal to the Search box
		var width = searchElement.outerWidth();
		suggestionElement.outerWidth(width);
		if (jQ('.fancybox-overlay').length > 0) {
			jQ(suggestionElement).css({
				'position': 'fixed',
				'overflow-y': 'scroll',
				'height': '100px'
			});
		}
	};

	// BoostPFS.prototype.afterBuildSearchBox = function(id) {
	// 	if (jQ(id).closest('form').length > 0){
	// 		var submitButton = jQ(id).closest('form').find('[type="submit"]');
	// 		if (submitButton && submitButton.length > 0){
	// 			submitButton.each(function(index, button){
	// 			button.setAttribute('name', 'bc-search-button');                
	// 			});
	// 		}
	// 	}
	// };

	// SearchInput.prototype._onSubmit = function(event, redirect) {
	// 	if (!redirect) {
	// 		// Stop all default submit events
	// 		event.stopImmediatePropagation();
	// 		//Moved preventDefault to only when redirect is applied since it causes conflicts with submit event of the theme
	// 		event.stopPropagation();
	// 		// Fix case can not get current value from input
	// 		Globals.currentTerm = this.$element.val();
	// 		if (!Globals.currentTerm && event && event.target) {
	// 		Globals.searchTerm = event.target.value;
	// 		}
	// 		var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
	// 		/**
	// 		 * if API returned results or the suggestionCache has the search term, submit search
	// 		 * else: add the data-search-submit attribute to the search input box, wait for the api returns the result, then remove this attribute in the checkForSearchRedirect function
	// 		 * @type {Boolean}
	// 		 */
	// 		var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(Globals.currentTerm.toString().trim());
	// 		// If the API returned results, either redirect or perform submit
	// 		if (isApiReturnedResult) {
	// 		if (redirectUrl) {
	// 			event.preventDefault();
	// 			window.location.href = redirectUrl;
	// 		} else {
	// 			this.$searchForm.trigger('submit', [true]);
	// 		}
	// 		} else {
	// 		event.preventDefault();
	// 		// If the API hasn't returned results, set data-search-submit on the search input and wait
	// 		this.$element.data('search-submit', true);
	// 		}
	// 	}
	// }
})();